(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mf-giftcard-hint"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mfGiftCardHint) return;
    window.__mfGiftCardHint = true;

    var MSG = 'That looks like a gift card! Gift cards go in at checkout: tap Check out, then enter it in the "Discount code or gift card" box. On a phone, tap Order summary at the top of checkout to find it.';
    var last = '';

    function looksLikeGiftCard(value) {
      var compact = String(value || '').replace(/[\s-]/g, '');
      return /^[a-z0-9]{16}$/i.test(compact) && /\d/.test(compact);
    }

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && form.matches && form.matches('.cart-discount__form')) {
        var input = form.querySelector('input[name="discount"]');
        last = input ? input.value : '';
      }
    }, true);

    new MutationObserver(function () {
      if (!last) return;
      document.querySelectorAll('[ref="cartDiscountErrorDiscountCode"]').forEach(function (el) {
        if (!el.dataset.mfOrig) el.dataset.mfOrig = el.textContent.trim();
        var want = looksLikeGiftCard(last) ? MSG : el.dataset.mfOrig;
        if (el.textContent.trim() !== want) el.textContent = want;
      });
    }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  })();
  } catch(e) { console.error(e); }
})();

})();
